"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingItemType = exports.StakingEventType = void 0;
var StakingEventType;
(function (StakingEventType) {
    StakingEventType["RuleCreated"] = "RuleCreated";
    StakingEventType["RuleUpdated"] = "RuleUpdated";
    StakingEventType["DepositStart"] = "DepositStart";
    StakingEventType["DepositWithdraw"] = "DepositWithdraw";
    StakingEventType["DepositFinish"] = "DepositFinish";
    StakingEventType["BalanceWithdraw"] = "BalanceWithdraw";
    StakingEventType["DepositReturn"] = "DepositReturn";
    StakingEventType["DepositPenalty"] = "DepositPenalty";
})(StakingEventType || (exports.StakingEventType = StakingEventType = {}));
var StakingItemType;
(function (StakingItemType) {
    StakingItemType["NATIVE"] = "0";
    StakingItemType["ERC20"] = "1";
    StakingItemType["ERC721"] = "2";
    StakingItemType["ERC998"] = "3";
    StakingItemType["ERC1155"] = "4";
})(StakingItemType || (exports.StakingItemType = StakingItemType = {}));
//# sourceMappingURL=staking.js.map